import { useTranslation } from 'react-i18next'
import { CategoryArchive } from '@/components/sections'
import type { Line } from '@/data/products'

const lineOrder: Line[] = ['man']

export function CategoryUomoPage() {
  const { t } = useTranslation('common')
  return (
    <CategoryArchive
      category="uomo"
      lineOrder={lineOrder}
      hero={{
        eyebrow: t('categoryUomo.hero.eyebrow'),
        title: t('categoryUomo.hero.title'),
        titleItalic: t('categoryUomo.hero.titleItalic'),
        intro: t('categoryUomo.hero.intro'),
        image: '/images/categories/uomo-hero.webp',
        imageAlt: t('categoryUomo.hero.imageAlt'),
      }}
      faq={{
        eyebrow: t('categoryUomo.faq.eyebrow'),
        title: t('categoryUomo.faq.title'),
        titleItalic: t('categoryUomo.faq.titleItalic'),
        body: (
          <>
            <p>{t('categoryUomo.faq.bodyParagraph1')}</p>
            <p>
              <strong className="text-bruno">{t('categoryUomo.faq.bodyQuestion')}</strong>{' '}
              {t('categoryUomo.faq.bodyParagraph2')}
            </p>
          </>
        ),
      }}
      labels={{
        filterByLine: t('categoryUomo.archiveLabels.filterByLine'),
        scrollLeft: t('categoryUomo.archiveLabels.scrollLeft'),
        scrollRight: t('categoryUomo.archiveLabels.scrollRight'),
        all: t('categoryUomo.archiveLabels.all'),
        linePrefix: t('categoryUomo.archiveLabels.linePrefix'),
        productsSuffix: t('categoryUomo.archiveLabels.productsSuffix'),
        defaultEyebrow: t('categoryUomo.archiveLabels.defaultEyebrow'),
        defaultFaqEyebrow: t('categoryUomo.archiveLabels.defaultFaqEyebrow'),
        categoryAriaLabel: t('categoryUomo.hero.ariaLabel'),
      }}
    />
  )
}
